<template>
  <v-container fluid tag="section">
    <v-row no-gutters>
      <v-col class="d-flex justify-center" md="3" cols="12">
        <v-radio-group row justify-center v-model="filter" @change="loadTable()">
          <v-radio v-if="typeView === 'M' || typeView === 'C'" :label="$t('reg_entry_p')" value="E"></v-radio>
          <v-radio v-if="typeView === 'M' || typeView === 'C'" :label="$t('reg_exit_p')" value="U"></v-radio>
          <v-radio v-if="typeView === 'M'" :label="$t('reg_internal_p')" value="G"></v-radio>
          <v-radio v-if="typeView === 'M'" :label="$t('all_m_p')" value="*ALL"></v-radio>
          <v-radio v-if="typeView === 'N'" :label="$t('reg_nota_grouped')" value="true"></v-radio>
          <v-radio v-if="typeView === 'N'" :label="$t('reg_nota_detailed')" value="false"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col class="d-flex justify-center" md="3" cols="12">
        <v-select v-model="selectedEsercizio" @change="setDateFromEsercizio" :items="listEsercizi" item-text="season"
          item-value="annoCurEse" :menu-props="{ maxHeight: '400' }" :label="$t('accounting_exercise')" required
          color="primary" :hint="$t('pick_accounting_exercise')" persistent-hint></v-select>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon color="primary" large v-on="on" style="cursor: pointer" class="mr-2"
              @click.native="loadTable()">mdi-refresh</v-icon>
          </template>
          <span>{{ $t("refresh") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon color="success" large v-on="on" style="cursor: pointer" class="mr-2"
              @click.native="createReg()">mdi-bank-plus</v-icon>
          </template>
          <span>{{ $t("create_contab_reg") }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon color="primary" large v-on="on" style="cursor: pointer" class="mr-2"
              @click.native="getPdf()">mdi-file-pdf-box</v-icon>
          </template>
          <span>{{ $t("download_pdf") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon color="primary" large v-on="on" style="cursor: pointer" class="mr-2"
              @click.native="getCsv()">mdi-file-excel-box</v-icon>
          </template>
          <span>{{ $t("download_xls") }}</span>
        </v-tooltip>
      </v-col>
      <v-col class="d-flex justify-center" md="3" cols="12">
        <my-datepicker v-model="dateInz" :label="$t('date_inz')" required="true" />
      </v-col>
      <v-col class="d-flex justify-center" md="3" cols="12">
        <my-datepicker v-model="dateEnd" :label="$t('date_end')" required="true" />
      </v-col>

    </v-row>

    <v-row>
      <v-col cols="12">
        <DataTables @editReg="editReg" @viewReg="viewReg" @copyReg="copyReg" @refoundReg="refoundReg" itemKey="key"
          :expandFields="['transactionCode', 'payerInfo']" @prtRicevuta="prtRicevuta" @prtAllegato="prtAllegato"
          :headers="headers" :tableData="tableData"></DataTables>
      </v-col>
    </v-row>
    <edit-cge ref="gestMovimentoDialog" @isUpdated="loadTable"></edit-cge>
  </v-container>
</template>

<script>
import gestMovimento from "@/app/contab/gestMovimento.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "list-cge",
  components: {
    MyDatepicker,
    DataTables,
    "edit-cge": gestMovimento,
  },
  props: {
    type: null,
  },
  data() {
    return {
      typeView: "M",
      filter: "*ALL",
      listEsercizi: [],
      selectedEsercizio: 0,
      dateInz: null,
      dateEnd: null,
      dialogEditReg: false,
      headers: [],
      tableData: [],
    };
  },
  computed: {
    dateRange() {
      return `${this.dateInz}|${this.dateEnd}`;
    },
  },
  methods: {
    setDateFromEsercizio(item) {
      let curEsercizio = this.listEsercizi.filter((esercizio) => {
        return esercizio.annoCurEse === item;
      });
      if (curEsercizio.length === 1) {
        this.dateInz = curEsercizio[0].dataInzEse;
        this.dateEnd = curEsercizio[0].dataFinEse;
        //this.loadTable();
      } else {
        this.dateInz = null;
        this.dateEnd = null;
      }
    },
    prtRicevuta(item) {
      let url =
        "/auth/contab/pdf/ricevuta/" + item.annoCge + "/" + item.numeCge;
      this.$documentViewer.documentViewerRsp.docUrl = url;
      //window.open(this.authorizeLink(url));
    },
    prtAllegato(item) {
      let url =
        "/auth/contab/prtAllegato/" +
        item.annoCge +
        "/" +
        item.numeCge +
        "/" +
        window.btoa(item.callParms.nome);
      this.$documentViewer.documentViewerRsp.docUrl = url;
      //window.open(this.authorizeLink(url));
    },
    getCsv(item) {
      let url = "";
      switch (this.typeView) {
        case "M":
          url =
            "/auth/contab/csv/listCge/" + new Date(this.dateInz).toISOString().substr(0, 10) + "/" + new Date(this.dateEnd).toISOString().substr(0, 10) +
            "/" +
            this.filter;
          break;
        case "N":
          url = "/auth/contab/csv/primaNota/" + new Date(this.dateInz).toISOString().substr(0, 10) + "/" + new Date(this.dateEnd).toISOString().substr(0, 10)
          break;
        case "S":
          url = "/auth/contab/csv/saldiMensili/" + new Date(this.dateInz).toISOString().substr(0, 10) + "/" + new Date(this.dateEnd).toISOString().substr(0, 10);
          break;
        case "C":
          url =
            "/auth/contab/csv/listCgeCdx/" + new Date(this.dateInz).toISOString().substr(0, 10) + "/" + new Date(this.dateEnd).toISOString().substr(0, 10) +
            "/" +
            this.filter;
          break;
      }
      window.open(this.authorizeLink(url));
    },
    getPdf(item) {
      let url = "";
      switch (this.typeView) {
        case "M":
          url =
            "/auth/contab/pdf/listCge/" + new Date(this.dateInz).toISOString().substr(0, 10) + "/" + new Date(this.dateEnd).toISOString().substr(0, 10) +
            "/" +
            this.filter;
          break;
        case "N":
          url = "/auth/contab/pdf/primaNota/" + new Date(this.dateInz).toISOString().substr(0, 10) + "/" + new Date(this.dateEnd).toISOString().substr(0, 10)
          break;
        case "S":
          url = "/auth/contab/pdf/saldiMensili/" + new Date(this.dateInz).toISOString().substr(0, 10) + "/" + new Date(this.dateEnd).toISOString().substr(0, 10);
          break;
        case "C":
          url =
            "/auth/contab/pdf/listCgeCdx/" + new Date(this.dateInz).toISOString().substr(0, 10) + "/" + new Date(this.dateEnd).toISOString().substr(0, 10) +
            "/" +
            this.filter;
          break;
      }
      this.$documentViewer.documentViewerRsp.docUrl = url;
      //window.open(this.authorizeLink(url));
    },
    viewReg(item) {
      this.$refs.gestMovimentoDialog.open("VIEW", item.annoCge, item.numeCge);
    },
    createReg() {
      this.$refs.gestMovimentoDialog.open("ADD", null, null);
    },
    editReg(item) {
      this.$refs.gestMovimentoDialog.open("EDIT", item.annoCge, item.numeCge);
    },
    refoundReg(item) {
      this.$refs.gestMovimentoDialog.open(
        "REFOUND",
        item.annoCge,
        item.numeCge
      );
    },
    copyReg(item) {
      this.$refs.gestMovimentoDialog.open("ADD", item.annoCge, item.numeCge);
    },
    loadEsercizi() {
      // Recupera esercizi
      let _ = this;
      _.listEsercizi = [];
      this.chiamataAxios("GET", "auth/contab/listEsercizi").then((response) => {
        _.listEsercizi = response.data.listEsercizi;
        _.selectedEsercizio = response.data.curEsercizio.annoCurEse;
        _.dateInz = response.data.curEsercizio.dataInzEse;
        _.dateEnd = response.data.curEsercizio.dataFinEse;
        //_.loadTable();
      });
    },
    loadTable() {
      let _ = this;
      let url = "";
      let now = new Date();

      // Testata
      _.headers = [];
      switch (_.typeView) {
        case "M":
          url = "/auth/contab/listCge";
          _.headers = [
            { text: this.$t("reg_number_short"), value: "numeCge" },
            { text: this.$t("reg_causal"), value: "descr" },
            { text: this.$t("type"), value: "iconType", type: "icons" },
            { text: this.$t("date"), value: "date", type: "datetime" },
            { text: this.$t("text"), value: "text", type: "html" },
            {
              text: this.$t("total"),
              value: "totale",
              type: "valuta",
              align: "end",
            },
            { text: this.$t("bank_accounts"), value: "conti", type: "html" },
            { text: this.$t("document_date"), value: "dateDoc", type: "date" },
            { text: this.$t("document_num"), value: "documento" },
            {
              text: this.$t("options"),
              value: "options",
              type: "buttons",
            },
          ];
          break;
        case "N":
          url = "/auth/contab/primaNota/" + _.filter;
          _.headers = [
            { text: this.$t("date"), value: "date", type: "date" },
            { text: this.$t("text"), value: "fullText", type: "html" },
            { text: this.$t("document_date"), value: "dateDoc", type: "date" },
            { text: this.$t("reg_serie"), value: "serie" },
            { text: this.$t("reg_protocol"), value: "protocollo" },
          ];
          break;
        case "S":
          url = "/auth/contab/saldiMensili";
          _.headers = [
            { text: this.$t("date"), value: "date", type: "date" },
          ];
          break;
        case "C":
          url = "/auth/contab/listCgeCdx/" + _.filter;
          _.headers = [
            { text: this.$t("reg_number_short"), value: "numeCge" },
            { text: this.$t("date"), value: "date", type: "date" },
            { text: this.$t("text"), value: "text", type: "html" },
            { text: this.$t("document_date"), value: "dateDoc", type: "date" },
            { text: this.$t("document_num"), value: "numeDoc" },
            { text: this.$t("reg_serie"), value: "serie" },
            { text: this.$t("reg_protocol"), value: "protocollo" },
          ];
          break;
      }
      _.tableData = [];
      let list = [];
      _.isFetching = true;
      let param = {
        dataInzEse: _.dateInz,
        dataFinEse: _.dateEnd,
        type: _.filter,
      };
      this.chiamataAxios("POST", url, { body: param }).then((response) => {
        // Customize response
        if (_.typeView === "M") {
          list = response.data;
        }

        if (_.typeView === "C") {
          list = response.data.data;
          response.data.listCdx.forEach((cdx) => {
            if (cdx.cdxId !== 0)
              _.headers.push({
                text: cdx.descr,
                value: "cdx_" + cdx.cdxId,
                type: "valuta",
                align: "end",
              });
          });
        }
        if (_.typeView === "N") {
          list = response.data.data;
          response.data.mastriNota.forEach((mastro) => {
            _.headers.push({
              text: "Entrate " + mastro.descr,
              value: "entrate_" + mastro.mastrCge + mastro.sotmaCge,
              type: "valuta",
              align: "end",
            });
            _.headers.push({
              text: "Uscite " + mastro.descr,
              value: "uscite_" + mastro.mastrCge + mastro.sotmaCge,
              type: "valuta",
              align: "end",
            });
            _.headers.push({
              text: "Saldo " + mastro.descr,
              value: "saldo_" + mastro.mastrCge + mastro.sotmaCge,
              type: "valuta",
              align: "end",
            });
          });
        } if (_.typeView === "S") {
          list = response.data.data;
          response.data.mastriNota.forEach((mastro) => {
            _.headers.push({
              text: "Saldo " + mastro.descr,
              value: "saldo_" + mastro.mastrCge + mastro.sotmaCge,
              type: "valuta",
              align: "end",
            });
          });
        }

        // Aggiunge actions e icona validazione
        if (_.typeView !== "M") {
          _.tableData = list;
        } else {
          _.tableData = list.map(function (item) {
            item.documento = item.numeDoc;
            if (item.type === "E") {
              item.iconType = [
                {
                  icon: "mdi-tray-plus",
                  color: "green",
                  text: _.$t("reg_entry"),
                },
              ];
            }
            if (item.type === "U") {
              item.documento = "[" + item.protocollo + "]" + item.documento;
              item.iconType = [
                {
                  icon: "mdi-tray-minus",
                  color: "red",
                  text: _.$t("reg_exit"),
                },
              ];
            }
            if (item.type === "R") {
              item.documento = "[" + item.protocollo + "]" + item.documento;
              item.iconType = [
                {
                  icon: "mdi-backburger",
                  color: "warning",
                  text: _.$t("refound"),
                },
              ];
            }
            if (item.type === "G") {
              item.iconType = [
                {
                  icon: "mdi-tray",
                  color: "primary",
                  text: _.$t("reg_internal"),
                },
              ];
            }

            item.options = [
              {
                icon: "mdi-magnify",
                color: "success",
                text: _.$t("view_reg"),
                function: "viewReg",
              },
              {
                icon: "mdi-pencil",
                color: "primary",
                text: _.$t("edit_reg"),
                function: "editReg",
              },
              {
                icon: "mdi-content-copy",
                color: "primary",
                text: _.$t("copy_reg"),
                function: "copyReg",
              },
            ];
            if (item.type === "E") {
              item.options.push({
                icon: "mdi-backburger",
                color: "error",
                text: _.$t("refound"),
                function: "refoundReg",
              });
              item.options.push({
                icon: "mdi-file-pdf-box",
                color: "warning",
                text: _.$t("receipt"),
                function: "prtRicevuta",
              });
            }
            if (item.allegati)
              item.allegati.forEach((allegato) => {
                item.options.push({
                  icon: "mdi-paperclip",
                  color: "warning",
                  text: _.$t("attachment") + ": " + allegato.name,
                  parms: { nome: allegato.name },
                  function: "prtAllegato",
                });
              });
            return item;
          });
        }
        _.isFetching = false;
      });
    },
  },
  mounted() {
    if (!this.type) this.typeView = "M";
    else this.typeView = this.type;
    if (this.typeView === "M") this.filter = "*ALL";
    if (this.typeView === "C") this.filter = "E";
    if (this.typeView === "N") this.filter = "false";
    if (this.typeView === "S") this.filter = "false";
    this.loadEsercizi();
  },
  watch: {
    dateRange: function (newVal, oldVal) {
      this.loadTable();
    },
    type: function (newVal, oldVal) {
      if (!this.type) this.typeView = "M";
      else this.typeView = this.type;

      if (newVal !== oldVal) {
        if (this.typeView === "M") this.filter = "*ALL";
        if (this.typeView === "C") this.filter = "E";
        if (this.typeView === "N") this.filter = "false";
        if (this.typeView === "S") this.filter = "false";
      }
      // watch it
      this.loadTable();
    },
  },
};
</script>